import { Box, Stack } from '@mui/material';

import Header from '../header/Header';
import { IPageProps } from '../LayoutPreference/layoutTypes';

const PageWithHeader = ({
  children,
  tabs,
  title,
}: IPageProps & { children: React.ReactNode }): React.ReactElement => {
  return (
    <Stack sx={{ display: 'flex', minHeight: '100dvh' }}>
      <Box
        sx={{
          position: 'sticky',
          top: 0,
          bgcolor: 'background.paper',
          zIndex: (theme) => theme.zIndex.appBar,
        }}
      >
        <Header title={title} tabs={tabs} />
      </Box>
      <Box
        sx={{
          display: 'flex',
          flex: 1,
          flexDirection: 'column',
          minHeight: 0,
          p: 3,
        }}
      >
        {children}
      </Box>
    </Stack>
  );
};

export default PageWithHeader;
